export default __webpack_public_path__ + "static/IBMPlexSans-MediumItalic-Latin1-14198366f48c7667783db6107814216e.woff2";